import api from '@/configurations/service';
import * as types from './mutation-types';

export const setIdentifiers = async (context) => {
  const { data } = await api().post('consumers.find-service-order-identifiers');

  context.commit(types.SET_IDENTIFIERS, data);
};

export const updateOsIdentifiers = async (_, payload) => {
  await api().post('consumers.update-service-order-identifiers', payload);
};
